module.exports = __webpack_public_path__ + "img/agePirod.50d0567c.svg";